import commonUtil from '../../../../../utils/commonUtil';

export const GET_DELIVERY_OPTION_LOAD = 'GET_DELIVERY_OPTION_LOAD';
export const GET_DELIVERY_OPTION_LOAD_SUCCESS = 'GET_DELIVERY_OPTION_LOAD_SUCCESS';
export const GET_DELIVERY_OPTION_LOAD_FAIL = 'GET_DELIVERY_OPTION_LOAD_FAIL';

export const DAY_NOT_APPLICABLE_LOAD = 'DAY_NOT_APPLICABLE_LOAD';
export const DAY_NOT_APPLICABLE_LOAD_SUCCESS = 'DAY_NOT_APPLICABLE_LOAD_SUCCESS';
export const DAY_NOT_APPLICABLE_LOAD_FAIL = 'DAY_NOT_APPLICABLE_LOAD_FAIL';

export const TEMPRORPY_ADDRESS_PREFERENCE_CHANGES = 'TEMPRORPY_ADDRESS_PREFERENCE_CHANGES';
export const REMOVE_TEMPRORPY_ADDRESS_PREFERENCE_CHANGES = 'REMOVE_TEMPRORPY_ADDRESS_PREFERENCE_CHANGES';
export const ADDRESS_PREFERENCE_CHANGES = 'ADDRESS_PREFERENCE_CHANGES';
export const WAPTEMPRORPY_ADDRESS_PREFERENCE_CHANGES = 'WAPTEMPRORPY_ADDRESS_PREFERENCE_CHANGES';

export function getdeliveryOptionOptedLoaded(globalState) {
  return globalState.giftPreferences.deliveryOptionOpted && globalState.giftPreferences.deliveryOptionOpted.loaded;
}

export function handleChangesInPreference(addressWithNewPreference) {
  return {
    type: ADDRESS_PREFERENCE_CHANGES,
    payload: addressWithNewPreference,
  };
}

export function handleTemproryChangesInPreference(payload) {
  return {
    type: TEMPRORPY_ADDRESS_PREFERENCE_CHANGES,
    payload,
  };
}

export function handleCancelTemproryAddressPreferenceChanges() {
  return {
    type: REMOVE_TEMPRORPY_ADDRESS_PREFERENCE_CHANGES,
  };
}
export function waphandleTemproryChangesInPreference(payload) {
  return {
    type: WAPTEMPRORPY_ADDRESS_PREFERENCE_CHANGES,
    payload,
  };
}

// for get preferred Delivery Day Details
export function preferredDeliveryDayDetails(eventId, DayOpted) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  payload.preferredDeliveryDayOpted = DayOpted;
  return {
    types: [GET_DELIVERY_OPTION_LOAD, GET_DELIVERY_OPTION_LOAD_SUCCESS, GET_DELIVERY_OPTION_LOAD_FAIL],
    promise: client => client.post('/api/EditEvent/preferredDeliveryDayDetails', {
      data: (payload),
    }),
  };
}

// for save Day of the Week For Address
export function saveDayoftheWeekForAddress(saveDayoftheWeekInfo, eventId) {
  const payload = {};
  payload.saveDayoftheWeekInfo = saveDayoftheWeekInfo;
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  return commonUtil.triggerServerRequest({ url: '/api/EditEvent/DayoftheWeekForAddress', method: 'POST', data: payload });
}

